<template>
  <ca-modal
    ref="modal"
    title="Cadastrar novo sindicato">
    <template slot="body">
      <union-form-page
        :is-valid.sync="isFormValid"
        :object.sync="union"
        :is-modal="true"></union-form-page>
    </template>

    <ca-row slot="footer">
      <ca-col size="3">
        <ca-button full-width @click="$refs.modal.close()">
          Cancelar
        </ca-button>
      </ca-col>
      <ca-col offset="6" size="3">
        <ca-request-button
          :disabled="!isFormValid"
          :on-request="onSubmit"
          :on-request-success="onSubmitSuccess"
          :on-request-error="onSubmitError"
          theme="primary">
          Confirmar
        </ca-request-button>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
import UnionFormPage from 'accountant/employer/unions/UnionsFormPage';
import { createNewUnion } from 'accountant/employer/unions/unionService';

export default {
  name: 'CreateUnionModal',
  components: {
    UnionFormPage,
  },
  data() {
    return {
      union: {},
      isFormValid: null,
    };
  },
  methods: {
    onSubmit() {
      return createNewUnion(this.union);
    },
    onSubmitSuccess() {
      this.$emit('created');
      this.$refs.modal.close();
      this.$toaster.success('Sindicato criado com sucesso!');
    },
    onSubmitError() {
      this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
    },
  },
};
</script>

<style scoped>
::v-deep .ca-heading--title {
  display: none;
}

::v-deep .ca-page-default {
  border: none;
  padding: unset;
}

::v-deep .ca-footer {
  display: none;
}
</style>
